import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {

  state: () => ({
    articleStateCounter: 0,
  }),

  actions: {
    addArticleStateCounter() {
      this.articleStateCounter++;
    },
    subArticleStateCounter() {
      this.articleStateCounter--;
    },
    resetArticleStateCounter() {
      this.articleStateCounter = 0;
    },
  },

});